import * as React from "react";
const SvgWord2 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 11.667, height: 5.833, x: 4.167, y: 7.083, stroke: "currentColor", strokeWidth: 1.25, rx: 0.833 }));
export default SvgWord2;
